<template>
    <div class="p-relative">
        <!--<div class="d-flex flex-wrap">
            <v-btn
                class="ma-1"
                depressed
                color="primary"
                @click="openContactDialog()"
                >
                Окно импорта номенклатуры
            </v-btn>

            <router-link 
                :to="{ name: 'DesignerForms' }"
                class="ma-1"
            >
                <v-btn
                    depressed
                    color="primary"
                >
                    Конструктор форм
                </v-btn>
            </router-link>
        </div>-->

        <ImportNomenclatureDlg ref="ImportNomenclatureRef"/>
    </div>
</template>

<script>
import ImportNomenclatureDlg from '@/components/dialogs/ImportNomenclatureDlg'
export default {
    name: "Sandbox",
    components:{
        ImportNomenclatureDlg
    },
    data: () => ({

    }),
    computed: {
        
    },
    methods: {
        async openContactDialog() {
            try {
                await this.$refs.ImportNomenclatureRef.open();
            } 
            catch (ex) {
                console.log(ex);
            }
        }
    }
}
</script>